import {
  Component,
  Input,
  OnDestroy,
  Inject,
  ViewEncapsulation
} from '@angular/core';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { LoaderService } from '../core/services/loader.service';
import { Subscribable, Subscription } from 'rxjs';

@Component({
  selector: 'app-spinner',
  template: `
      <div [ngClass]="isSpinnerVisible ? 'loaderOverlay':''"></div>
      <div class="load-bar" [class.hidden]="!isSpinnerVisible">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
    `
})
export class SpinnerComponent implements OnDestroy {
  public isSpinnerVisible = false;
  public subscription: Subscription;
  @Input() public backgroundColor = 'rgba(0, 115, 170, 0.69)';

  constructor(
    private router: Router,
    private loader: LoaderService
  ) {
    this.subscription =  this.loader.loaderState.subscribe((response) => {
      console.log(response)
      this.isSpinnerVisible = response.show;
    });
  }


  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
